<div class="loader-wrapper">
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  />
  <div class="brand-calendar-view-wrapper">
    <div class="calendar-header brand-view">
      <div class="left-content">
        <div
          class="button-transparent today"
          [class.active]="isCalendarOnThisMonth()"
          mwlCalendarToday
          [(viewDate)]="viewDate"
        >
          <span>{{ "shared.today" | translate }}</span>
        </div>
        <div class="calendar-navigation">
          <div
            class="button-navigation"
            mwlCalendarPreviousView
            [view]="VIEW_TYPE"
            [(viewDate)]="viewDate"
          >
            <span
              ><mat-icon
                class="mat-icon material-icons"
                role="img"
                aria-hidden="true"
                >arrow_back_ios</mat-icon
              ></span
            >
          </div>
          <div
            class="button-navigation"
            mwlCalendarNextView
            [view]="VIEW_TYPE"
            [(viewDate)]="viewDate"
          >
            <span
              ><mat-icon
                class="mat-icon material-icons"
                role="img"
                aria-hidden="true"
                >arrow_forward_ios</mat-icon
              ></span
            >
          </div>
        </div>
        <h3>
          {{ viewDate | calendarDate: VIEW_TYPE + "ViewTitle" : language() }}
        </h3>
      </div>
    </div>

    <mwl-calendar-month-view
      [viewDate]="viewDate"
      [cellTemplate]="customCellTemplate"
      [events]="events"
      [refresh]="refresh"
      [locale]="language()"
      [weekStartsOn]="1"
      (eventTimesChanged)="eventTimesChanged($event)"
      (mouseup)="onMouseUp()"
    />

    <ng-template #customCellTemplate let-day="day">
      <div class="custom-cal-day-cell" (mouseover)="mouseOverDay(day.date)">
        <div
          [ngClass]="{ 'cal-day-cell--outbound': isDayOutsideRange(day.date) }"
        >
          <div class="cal-cell-top">
            <span class="cal-day-number">
              <i
                *ngIf="isDayOutsideRange(day.date)"
                class="cal-day-outbound-icon material-icons"
                >block</i
              >
              {{ day.date | calendarDate: "monthViewDayNumber" : language() }}
            </span>
          </div>
          <div class="cal-events">
            <ng-container *ngFor="let event of getFilledEventArray(day.date)">
              <ng-container *ngIf="!isEmptyObject(event)">
                <div
                  mwlDraggable
                  class="cal-event"
                  [ngClass]="{
                    'is-first-day':
                      isMultiDayPost(event.post) && isFirstDay(day.date, event),
                    'is-center-day':
                      isMultiDayPost(event.post) &&
                      isCenterDay(day.date, event),
                    'is-last-day':
                      isMultiDayPost(event.post) && isLastDay(day.date, event),
                    'is-being-dragged': event.isBeingDragged,
                    'is-approved': true,
                    'cal-event--partner': true,
                    'cal-event--partner--facebook': event.post.isFacebookPost,
                    'cal-event--partner--google': event.post.isGoogleAd,
                    'cal-event--partner--linkedin': event.post.isLinkedInPost,
                    'cal-event--isDarkPost': event.post.isDarkPost,
                    'cal-event--hasPromoAds':
                      event.post.willBecomeAd || event.post.isGoogleAd,
                    loading: isEventLoading(event),
                    collapsed: false
                  }"
                  [dropData]="{ event: event }"
                  [dragAxis]="{
                    x: event.draggable && !event.loading,
                    y: event.draggable && !event.loading
                  }"
                  (dragStart)="onEventDragStart(event, day.date)"
                  (mwlClick)="onEventClick($event, event)"
                >
                  <ng-container
                    *ngIf="isOneDayEvent(event) || isFirstDay(day.date, event)"
                  >
                    <!-- FACEBOOK AD -->
                    <div class="event-icon">
                      <img
                        *ngIf="showFacebookIcon(event.post)"
                        src="/assets/images/facebook-post-logo.svg"
                        width="16"
                      />
                      <img
                        *ngIf="showInstagramIcon(event.post)"
                        src="/assets/images/instagram-post-logo.svg"
                        width="16"
                      />
                    </div>
                    <div
                      *ngIf="event.post.isFacebookPost"
                      class="event-content"
                    >
                      <div class="event-text">{{ event.title }}</div>
                      <div
                        *ngIf="event.post.willBecomeAd"
                        class="promo-ads-text"
                      >
                        PROMO ADS
                      </div>
                      <div class="dark-post" *ngIf="event.post.isDarkPost">
                        <img
                          src="/assets/images/icons/ic_dark_post_Calendar.svg"
                          width="10"
                        />
                        <div class="promo-ads-text">DARK POST</div>
                      </div>
                    </div>

                    <!-- GOOGLE AD -->
                    <div *ngIf="event.post.isGoogleAd" class="event-icon">
                      <img src="/assets/images/google-ad-logo.svg" width="16" />
                    </div>
                    <div *ngIf="event.post.isGoogleAd" class="event-content">
                      <div class="event-text">{{ event.title }}</div>
                      <div class="promo-ads-text">PROMO ADS</div>
                    </div>

                    <ng-container *ngIf="event.post.isLinkedInPost">
                      <div class="event-icon">
                        <img
                          src="/assets/images/icons/linkedin/ic_linkedin.svg"
                          width="16"
                          alt="LinkedIn"
                        />
                      </div>
                      <div class="event-content">
                        <div class="event-text">{{ event.title }}</div>
                      </div>
                    </ng-container>

                    <mat-icon class="loading-icon">loop</mat-icon>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      !isOneDayEvent(event) && !isFirstDay(day.date, event)
                    "
                  >
                    <div class="event-content"></div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="isEmptyObject(event)">
                <div class="empty-event"></div>
              </ng-container>
            </ng-container>
          </div>
          <img
            *ngIf="showAddPostButton(day)"
            class="add-post-icon"
            src="/assets/images/icons/ic_addCalendar.svg"
            (click)="checkAndShowSelectPostDialog(day)"
          />
        </div>
      </div>
    </ng-template>
  </div>
</div>
